import { Container, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout'
import { Checkbox } from '@progress/kendo-react-inputs'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import TextAreaWrapper from '../../onboarding/steps/inputs/textareaWrapper'
import InputPureWrapper from '../../onboarding/steps/inputs/inputPureWrapper'
import { ButtonHLPure } from '../../../pures'
import { useTranslation } from 'react-i18next'

const UserNodeDetails = (props) => {
    const { node, onSaveNode } = props
    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig.conversations' })
    const { t: tCommon } = useTranslation('common')

    const [data, setData] = useState(node.data)
    const [formKey, setFormKey] = useState(1)
    const resetForm = () => setFormKey(formKey + 1)

    const onSubmit = async (formData) => {
        await onSaveNode(formData)
        setData(prev => ({ ...prev, ...formData }))
        resetForm()
    }

    return (
        <Container disableGutters>
            <Form
                key={`usernode-${formKey}`}
                initialValues={data}
                onSubmit={onSubmit}
                render={(formRenderProps) => {
                    return (
                        <FormElement>
                            <Grid container spacing={2} className='conversation-node-form user-node-form'>
                                <Grid item xs={12}>
                                    <h3>{t("userNode.title")}</h3>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id="isSuggestion"
                                        name={'isSuggestion'}
                                        component={Checkbox}
                                        label={t("userNode.isSuggestion")}
                                    />
                                </Grid>
                                {
                                    formRenderProps.valueGetter("isSuggestion") &&
                                    <Field
                                        id="suggestedText"
                                        name={'suggestedText'}
                                        component={InputPureWrapper}
                                        label={t("userNode.suggestedText")}
                                    />
                                }
                                <Grid item xs={12}>
                                    <Field
                                        id="keyWords"
                                        name={'keyWords'}
                                        component={InputPureWrapper}
                                        label={t("userNode.keyWords")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id="description"
                                        name={'description'}
                                        component={TextAreaWrapper}
                                        label={t("userNode.description")}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <PanelBar>
                                        <PanelBarItem title={t("advancedSettings")}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        id="functionName"
                                                        name={'functionName'}
                                                        component={InputPureWrapper}
                                                        label={t("userNode.functionName")}
                                                    />
                                                    <p className='hint'>{t("userNode.functionNameHint")}</p>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Field
                                                        id="loadingMessage"
                                                        name={'loadingMessage'}
                                                        component={InputPureWrapper}
                                                        label={t("userNode.loadingMessage")}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Field
                                                        id="variables"
                                                        name={'variables'}
                                                        component={InputPureWrapper}
                                                        label={t("userNode.variables")}
                                                    />
                                                </Grid>
                                            </Grid>

                                        </PanelBarItem>
                                    </PanelBar>
                                </Grid>

                                <Grid item xs={12} className='button-actions'>
                                    {
                                        formRenderProps.modified &&
                                        <>
                                            <ButtonHLPure
                                                colorScheme="error"
                                                outlined
                                                nameBtn={tCommon("cancel")}
                                                onClick={resetForm}
                                            />
                                            <ButtonHLPure
                                                primary
                                                nameBtn={tCommon("save")}
                                                type="submit"
                                            />
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </FormElement>
                    )
                }}
            />
        </Container>
    )
}

export default UserNodeDetails